import {Button, Card, Col, Row, Space} from "antd";
import {useTranslation} from "react-i18next";
import {CloseCircleFilled, CustomerServiceOutlined, FileTextOutlined, LockOutlined} from "@ant-design/icons";
import VerificationPending from "./VerificationPending";

function VerificationStatusScreen(props) {
    const {statusHistory, onTryAgain, onStartOver, userVerificationTiers} = props;
    const {t} = useTranslation();
    const status = statusHistory?.status;

    const formatLimit = (val) => {
        if (val === null || val === undefined) return "Unlimited";
        const {dailyMax, allTimeMax} = val;
        if (dailyMax > 0) return `${Number(dailyMax).toLocaleString()} USD Daily`;
        if (allTimeMax > 0 && allTimeMax !== -1) return `${Number(allTimeMax).toLocaleString()} USD`;
        return "Unlimited";
    };

    if (status === "verification_failed") {
        const tierId = statusHistory?.tierSetting?._id || statusHistory?.tierSetting;
        const tier = userVerificationTiers?.find(t => t._id === tierId);
        const accessRightsList = Object.entries(tier?.accessRights || {});
        const accessWithAmounts = accessRightsList.filter(([_, val]) => val !== null && val !== undefined);

        return (
            <div className="verification-status-wrap">
                <Space direction="vertical" size={16} style={{width: "100%"}}>
                    <Card className="verification-status-card" bordered={false}>
                        <Space direction="vertical" size={16} style={{width: "100%"}}>
                            <div className="verification-status-header">
                                <CloseCircleFilled className="verification-status-icon danger"/>
                                <div>
                                    <div className="verification-status-title">Verification Unsuccessful</div>
                                    <div className="verification-status-subtitle">• Please restart your verification.
                                    </div>
                                </div>
                            </div>

                            <Row gutter={12} className="verification-status-actions">
                                <Col xs={24} sm={12}>
                                    <Button className="primary_btn" block onClick={onTryAgain}>
                                        Try Again
                                    </Button>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Button className="secondary_btn" block onClick={onStartOver}>
                                        Start from Beginning
                                    </Button>
                                </Col>
                            </Row>

                            <Row gutter={24} className="verification-help-links">
                                <Col>
                                    <Space size={6}>
                                        <CustomerServiceOutlined className="verification-help-icon"/>
                                        <span className="verification-help-link-text">Need help?</span>
                                    </Space>
                                </Col>
                                <Col>
                                    <Space size={6}>
                                        <FileTextOutlined className="verification-help-icon"/>
                                        <span className="verification-help-link-text">Identity Verification FAQ</span>
                                    </Space>
                                </Col>
                            </Row>
                        </Space>
                    </Card>

                    {accessWithAmounts.length > 0 && (
                        <Card className="verification-limits-card" bordered={false}>
                            <h3 className="verification-limits-title">Account Limits After Verification</h3>
                            <Space direction="vertical" size={14} style={{width: "100%"}}>
                                {accessWithAmounts.map(([module, val]) => (
                                    <Row key={module} justify="space-between" align="middle"
                                         className="verification-limit-row">
                                        <Space size={10}>
                                            <LockOutlined className="verification-limit-icon"/>
                                            <span className="verification-limit-label">
                                                {t(`accountVerification.tierSettingAccessRight.${module}`, module.replace(/_/g, " "))}
                                            </span>
                                        </Space>
                                        <span className="verification-limit-value">{formatLimit(val)}</span>
                                    </Row>
                                ))}
                            </Space>
                        </Card>
                    )}
                </Space>
            </div>
        )
    }

    return <VerificationPending/>
}

export default VerificationStatusScreen;
